var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKitimatLogoHorizontal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 73,
    viewBox: "0 0 300 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_695_23806)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4899 38.2044L16.4036 44.9885H8.57555L12.4899 38.2044ZM2.93305 37.2024H10.7581L6.93329 43.8328L2.93305 37.2024ZM6.84444 28.4194L10.7581 35.2031H2.90026L6.84444 28.4194ZM16.4154 27.3971L12.4899 34.2018L8.56212 27.3942L16.4154 27.3971ZM14.221 37.2024H23.0929L23.6998 36.1438L23.1608 35.2031H14.221L18.7051 27.4302L17.5396 25.3975L6.28937 25.3939L0 36.2123L6.50182 46.9884H17.4829L18.6707 44.9163L14.221 37.2024Z",
    fill: "#2E3285"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7504 37.2024H80.5306L76.65 43.9613L72.7504 37.2024ZM67.1052 44.9885L71.0193 38.2044L74.9336 44.9885H67.1052ZM67.1026 27.4131L74.9346 27.4155L71.0193 34.2018L67.1026 27.4131ZM80.5391 35.2031H72.7507L76.6745 28.402L80.5391 35.2031ZM83.4091 36.2057L77.2782 25.4155L66.0361 25.4123L64.8414 27.4965L69.2878 35.2031H60.4238L59.8848 36.1438L60.4917 37.2024H69.2881L64.8758 44.8498L66.1016 46.9884H77.2182L83.4091 36.2057Z",
    fill: "#2E3285"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8089 2.99077L54.7043 9.74239H46.9136L50.8089 2.99077ZM60.3908 2.01111L56.4702 8.80109L52.5663 2.03503L60.3908 2.01111ZM66.0624 9.74239H58.2364L62.13 2.99833L66.0624 9.74239ZM62.1176 18.5897L58.1669 11.7423H66.0709L62.1176 18.5897ZM45.793 11.7423H54.7718L50.2811 19.5215L50.8381 20.4795L52.0352 20.4828L56.4699 12.8023L60.9169 20.5103L63.3143 20.5176L68.9593 10.7401L62.6992 0.00428963L50.2008 0.0416355L44.5996 9.75028L45.776 11.7732L45.793 11.7423Z",
    fill: "#2E3285"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3996 11.7423L21.4311 18.6215L17.4595 11.7423H25.3996ZM21.4072 3.00941L25.2946 9.74239H17.5391L21.4072 3.00941ZM31.0001 2.03503L27.0785 8.83222L23.1406 2.01111L31.0001 2.03503ZM36.6174 9.74239H28.8621L32.7394 3.02192L36.6174 9.74239ZM27.0789 12.8335L31.4955 20.4835L32.7473 20.4795L33.2771 19.5685L28.7589 11.7423H37.7715L37.7993 11.7912L38.9583 9.79745L33.3296 0.0416355L20.8276 0.00428963L14.6152 10.8161L20.2164 20.5176L22.6498 20.5103L27.0789 12.8335Z",
    fill: "#2E3285"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2164 10.242L41.7695 14.6577L44.6005 9.75028L41.7937 4.92248L38.959 9.79745L39.2157 10.2424L39.2164 10.242Z",
    fill: "#2E3285"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.099 46.9786H49.1016L51.8877 51.8037L60.8675 51.7769L58.099 46.9786Z",
    fill: "#2E3285"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6035 20.5907L25.3766 25.3991L34.3376 25.4056L31.4954 20.4835L22.6497 20.5103L22.6035 20.5907Z",
    fill: "#2E3285"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1163 24.4856L40.6244 16.6878L37.7995 11.7912L33.2773 19.5685L36.1163 24.4856Z",
    fill: "#2E3285"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9846 21.0907L60.4902 25.4106L66.0377 25.4123L68.8341 20.5346L63.3152 20.5176L62.984 21.0907H62.9846Z",
    fill: "#2E3285"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2984 44.9787H64.8022L64.8763 44.8498L60.4922 37.2024H54.8027L59.2984 44.9787Z",
    fill: "#2E3285"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3273 27.4233L54.8359 35.2031H60.4243L64.842 27.4965L64.8023 27.4272L59.3273 27.4233Z",
    fill: "#2E3285"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1875 25.4158L58.1732 25.4224L59.0073 23.9778L60.963 20.5903L60.9171 20.5103L52.0353 20.4828L49.1875 25.4158Z",
    fill: "#2E3285"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9375 16.6809L47.4322 24.4548L50.2803 19.5215L45.7752 11.7732L42.9375 16.6809Z",
    fill: "#2E3285"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9831 51.3513L62.9448 51.3736L63.173 51.7697L68.8332 51.7523L66.1024 46.9885H60.4609L62.9831 51.3513Z",
    fill: "#2E3285"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5832 51.3513L23.1058 46.9885H17.4827L14.752 51.7523L20.3574 51.7697L20.5947 51.3579L20.5832 51.3513Z",
    fill: "#2E3285"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0195 62.5963L41.792 67.3644L44.5365 62.6438L41.7644 57.8423L39.0195 62.5963Z",
    fill: "#2E3285"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4152 48.0563L42.9258 55.8325L45.6997 60.6439L50.2073 52.8926L47.4152 48.0563Z",
    fill: "#2E3285"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6169 55.8315L36.1249 48.0419L33.3516 52.8457L37.8623 60.6029L40.6169 55.8315Z",
    fill: "#2E3285"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.428 46.9786H25.4302L22.6621 51.7769L31.6419 51.8037L34.428 46.9786Z",
    fill: "#2E3285"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1299 25.3942L23.0331 25.3975L20.216 20.5176L14.752 20.5346L17.5394 25.3975H18.1299V25.3942Z",
    fill: "#2E3285"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7207 35.2031L24.2207 27.3994L18.7241 27.3981L18.7051 27.4302L23.1607 35.2031H28.7207Z",
    fill: "#2E3285"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.706 44.9787H24.2675L28.7628 37.2024H23.0922L18.6699 44.9163L18.706 44.9787Z",
    fill: "#2E3285"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9597 69.2486L58.1388 62.6307L65.8451 62.6231L61.9597 69.2486ZM52.652 70.2594L56.4414 63.6914L60.2233 70.2414L52.652 70.2594ZM46.8456 62.6412L54.7421 62.634L50.7934 69.4791L46.8456 62.6412ZM62.0918 53.8981L65.9179 60.5308L58.2401 60.574L62.0918 53.8981ZM63.1727 51.7697L60.8679 51.7769L60.937 51.8965L56.4411 59.6898L51.8881 51.8037L50.8379 51.807L50.2068 52.8926L54.6532 60.5937L45.6997 60.6438L44.5371 62.6438L50.0924 72.2656L62.5265 72.2354L68.8051 61.5314L63.1727 51.7697Z",
    fill: "#2E3285"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7544 69.4479L28.8086 62.6078L36.6992 62.615L32.7544 69.4479ZM23.307 70.2414L27.1067 63.6602L30.9134 70.2594L23.307 70.2414ZM17.6695 62.5979L25.406 62.6045L21.5701 69.2486L17.6695 62.5979ZM21.4563 53.867L25.3106 60.5482L17.6272 60.5045L21.4563 53.867ZM39.0136 62.6071L39.0198 62.5963L37.8609 60.6029L37.852 60.6183L28.8915 60.5675L33.3502 52.8457L32.7465 51.807L31.642 51.8037L27.107 59.6586L22.6107 51.8653L22.6622 51.7769L20.357 51.7697L14.7246 61.5314L21.0039 72.2354L33.437 72.2656L39.0074 62.6176H39.0198L39.0136 62.6071Z",
    fill: "#2E3285"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5312 27.4004L31.0239 35.2031H39.9949L35.49 27.3981L26.5312 27.4004Z",
    fill: "#2E3285"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0122 27.4004L52.5191 35.2031H43.5488L48.0533 27.3981L57.0122 27.4004Z",
    fill: "#2E3285"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7838 18.6789L37.2695 26.502L41.7658 34.2707L46.2621 26.4673L41.7838 18.6789Z",
    fill: "#2E3285"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5781 44.9787L31.0718 37.2024H40.0725L35.5806 44.9787H26.5781Z",
    fill: "#2E3285"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9886 44.9787L52.5087 37.2024H43.459L47.9458 44.9787H56.9886Z",
    fill: "#2E3285"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7711 53.8309L37.2754 46.0351L41.7651 38.2713L46.2555 46.0409L41.7711 53.8309Z",
    fill: "#2E3285"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.582 14.8203H107.44V32.2432L125.635 14.8203H133.801L113.072 34.7245L133.935 57.7122H126.476L107.44 36.7874V57.7122H101.582V14.8203Z",
    fill: "#2E3285"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.182 14.8203H142.972V57.7122H137.182V14.8203Z",
    fill: "#2E3285"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.807 14.8203H173.033V20.6789H162.798V57.7122H157.007V20.6789H146.807V14.8203Z",
    fill: "#2E3285"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.705 14.8203H182.496V57.7122H176.705V14.8203Z",
    fill: "#2E3285"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.115 14.8203L236.847 57.7122H231.106L224.007 32.2003L211.783 57.7122L199.523 31.9606L192.325 57.7122H186.617L198.35 14.8203L211.778 43.3525L225.115 14.8203Z",
    fill: "#2E3285"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.113 57.7122L259.862 14.8203L239.779 57.7122H245.873L259.847 28.2063L267.169 43.5H252.413L250.15 48.3825H269.507L273.974 57.7122H280.113Z",
    fill: "#2E3285"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.773 14.8203H300V20.6789H289.765V57.7122H283.974V20.6789H273.773V14.8203Z",
    fill: "#2E3285"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_695_23806"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 72.2659,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKitimatLogoHorizontal);
export default __webpack_public_path__ + "static/media/kitimat-logo-horizontal.779ef543f854a57e4df044c94fad3990.svg";
export { ForwardRef as ReactComponent };